import type { ConversationRow } from "../api";

/**
 * "A customer has been waiting too long" — which conversations deserve the
 * reminder right now.
 *
 * Only the operator's own conversations and the ones nobody has taken: a
 * reminder about a colleague's chat is somebody else's to act on, and ringing
 * every console for it teaches people to ignore the sound. Each wait is
 * reminded once — the key includes when it started, so the same visitor
 * writing again after an answer is a new wait and may be reminded again.
 */
export function dueReminders(
  rows: Array<Pick<ConversationRow, "id" | "waitingSince" | "assignedOperatorId" | "status">>,
  now: number,
  afterMinutes: number,
  me: number,
  reminded: Set<string>,
): Array<{ id: number; key: string; minutes: number }> {
  if (afterMinutes <= 0) return [];
  const due: Array<{ id: number; key: string; minutes: number }> = [];
  for (const row of rows) {
    if (!row.waitingSince || (row.status !== "pending" && row.status !== "open")) continue;
    if (row.assignedOperatorId !== null && row.assignedOperatorId !== me) continue;
    const waited = now - new Date(row.waitingSince).getTime();
    if (!(waited >= afterMinutes * 60_000)) continue;
    const key = `${row.id}:${row.waitingSince}`;
    if (reminded.has(key)) continue;
    due.push({ id: row.id, key, minutes: Math.floor(waited / 60_000) });
  }
  return due;
}

/** The choices offered in the notification settings, in minutes; 0 is off. */
export const REMINDER_CHOICES = [0, 1, 2, 3, 5, 10] as const;
